// import langJson from '/public/lang.json';
// const lang = JSON.parse(sessionStorage.getItem('localeResource')) || langJson || {};
const lang = JSON.parse(sessionStorage.getItem('localeResource')) || {
  zh_CN: {},
  zh_TW: {},
  en_US: {},
  fr_FR: {},
  ru_RU: {},
  es_ES: {}
};
// sessionStorage.setItem('localeResource', JSON.stringify(langJson));
sessionStorage.setItem('localeResource', JSON.stringify(lang));
const messages = {
  zh_CN: {
    ...lang.zh_CN
  },
  zh_TW: {
    ...lang.zh_TW
  },
  en_US: {
    ...lang.en_US
  },
  es_ES: {
    ...lang.es_ES
  },
  fr_FR: {
    ...lang.fr_FR
  },
  ru_RU: {
    ...lang.ru_RU
  }
};
export default messages;